import React from "react";

const Prompt = () => <span className={"prompt"}>Root@Portifolio:~$ </span>;

export default Prompt;
